import React from "react";
import { FileText } from "lucide-react";
import GlobalDetailDrawer from "modules/swiftboard/components/GlobalDetailDrawer";
import LocalDateTime from "services/date-converter";
import ActiveBadge from "../../../components/ActiveBadge";
import { schemaFields } from "../features/template.utils";

function ContentList({ content, schema }) {
  const fields = schemaFields(schema).filter(({ key }) => content?.[key] !== undefined && content[key] !== "");
  if (!fields.length) return <span className="text-xs text-text_muted">Empty</span>;
  return (
    <dl className="divide-y divide-border rounded-lg border border-border">
      {fields.map(({ key, prop }) => (
        <div key={key} className="px-3 py-2">
          <dt className="text-[11px] text-text_muted">
            {prop.title ?? key} <span className="font-mono">{key}</span>
          </dt>
          <dd className="whitespace-pre-wrap break-words font-mono text-[11px] text-text_primary">{Array.isArray(content[key]) ? content[key].join(", ") : String(content[key])}</dd>
        </div>
      ))}
    </dl>
  );
}

// Read-only view of one template (fetched with its channel and trigger by the list page). Content is shown as written,
// placeholders included; open Edit for the rendered preview.
export default function TemplateViewDrawer({ record, onClose }) {
  const schema = record.channel?.template_schema;
  const sections = [
    {
      title: "Template",
      fields: [
        { label: "Name", value: record.name },
        { label: "Code", value: <span className="font-mono">{record.code}</span> },
        { label: "Channel", value: record.channel ? `${record.channel.name} (${record.channel.channel_key})` : "—" },
        { label: "Trigger", value: record.trigger ? `${record.trigger.name} (${record.trigger.code})` : "Generic (any trigger)" },
        { label: "Locale", value: <span className="font-mono">{record.locale}</span> },
        { label: "Version", value: `v${record.version_no}` },
        { label: "Updated", value: record.updated_date ? <LocalDateTime utcTime={record.updated_date} /> : "—" },
        { label: "Status", value: <ActiveBadge active={record.is_activated} /> },
      ],
    },
    { title: "Message", fields: [{ value: <ContentList content={record.content} schema={schema} /> }] },
    ...(record.digest_content ? [{ title: "Digest version", fields: [{ value: <ContentList content={record.digest_content} schema={schema} /> }] }] : []),
  ];
  return <GlobalDetailDrawer open onClose={onClose} title={record.name} subtitle={record.code} icon={<FileText size={20} />} sections={sections} />;
}
